import { render } from "./emailList.vue?vue&type=template&id=1affe81e"
import script from "./emailList.vue?vue&type=script&lang=js"
export * from "./emailList.vue?vue&type=script&lang=js"

import "./emailList.vue?vue&type=style&index=0&id=1affe81e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__